// extracted by mini-css-extract-plugin
module.exports = {"checkboxBase":"Checkbox_checkboxBase__zAOmB","disabled":"Checkbox_disabled__gdsft","checked":"Checkbox_checked__RStmc","focused":"Checkbox_focused__VDIPL"};